export default function(value) {
  return value instanceof Date;
}
